// extracted by mini-css-extract-plugin
export default {"form":"PatientStep8_form__izQ4t"};